import type { Layout, PaletteModel } from '../../data/types';
import { waterAccesses } from '../../site/waterAccess';
import { layoutToWorld } from '../../core/coords';
import type { ChunkSink } from '../mesh/chunker';
import { SURFACE, edgeIdFor } from '../mesh/attributes';
import { buildWaterSteps } from './waterSteps';
import { buildCornerWaterSteps } from './cornerWaterSteps';
import { prismSolid } from '../fabric/solids';
import type { VertexStyle } from '../mesh/meshBuilder';

/** Every painted flight is built from the same profile the walking queries use. */
export function buildAccessStairs(
  layout: Layout,
  palette: PaletteModel,
  chunks: ChunkSink
): number {
  const flights = waterAccesses(layout);
  flights.forEach((flight, i) => {
    const builder = chunks.builderAt('infrastructure', flight.origin);
    const frame = { origin: layoutToWorld(flight.origin, 0), yaw: flight.heading };
    const style: VertexStyle = {
      color: palette.towerStone.median.linear,
      surface: SURFACE.stone,
      edgeId: edgeIdFor(20100 + i),
      seed: 0,
      strokeAngle: 0,
      extent: [flight.width, 2.5],
    };
    if (flight.corner) buildCornerWaterSteps(builder, style, frame, flight, flight.landing);
    else buildWaterSteps(builder, style, frame, flight);
    const back = flight.landingBackWidth ?? flight.width / 2;
    prismSolid(
      builder,
      style,
      frame,
      [
        [-flight.landing, -flight.width / 2],
        [0, -flight.width / 2],
        [0, back],
        [-flight.landing, back],
      ],
      flight.footY,
      flight.topY,
      { top: true, bottom: true }
    );
  });
  return flights.length;
}
